var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.items)?_c('Loading'):_c('div',{ref:"rt",staticClass:"NavMenu",attrs:{"role":"menu"}},_vm._l((_vm.items),function(item){return _c('NavMenuItem',{key:item.id,attrs:{"item":item,"level":0,"parent":null,"evolutionDisable":_vm.evolutionDisable,"keepOneLevelOpen":_vm.keepOneLevelOpen,"branchAction":_vm.$props.branchAction}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }